<template lang="pug">
  router-link.fw--board-preview(:to="{name: isAdmin ? 'AdminBoard' : 'PublicBoard', params: { boardSlug: board.slug }}")
    .fw--board-preview-body
      h3 {{ board.name }}
      p {{ board.description }}
      h5 {{ company.subdomain }}.feature.watch/{{ board.slug }}
    .fw--board-preview-footer
      .row.apart
        .col
          span {{ featureCountMessage }}
        .col(v-if="admin")
          router-link(:to="{ name: 'BoardSettingsGeneral', params: { boardSlug: board.slug }}")
            font-awesome-icon(:icon="['fad', 'cog']")

</template>

<script>

import { mapState } from 'vuex'

export default {
  props: {
    board: Object,
    admin: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
    }
  },
  beforeMount () {
  },
  computed: {
    ...mapState({
      company: state => state.company
    }),
    featureCountMessage () {
      let message = ''
      if (this.board.stats.active_features > 1) {
        message = `${this.board.stats.active_features} Posts` 
      } else if (this.board.stats.active_features === 1) {
        message = `${this.board.stats.active_features} Post` 
      } else {
        message = `No Posts Yet!`
      }
      return message
    },

    isAdmin () {
      return this.$route.matched[0].meta.member
    }
  },
  methods: {
  }
}

</script>

<style scoped lang="stylus">
.fw--board-preview
  border $border-default
  border-radius $border-radius
  display flex
  flex-direction column
  height 100%
  h3
    margin-bottom $spacing-2

  p
    margin-bottom $spacing-2

  h5
    color $text-light
    font-size $text-size-small
    font-weight 200

  &:hover
    border-color $color-primary
    transition 300ms

.fw--board-preview-body
  flex 1
  padding $spacing-3 $spacing-2
  text-align center

.fw--board-preview-footer
  background-color $background-color
  padding $spacing
</style>
